module.exports = __webpack_public_path__ + "img/statement.826bfde5.svg";